/* eslint-disable no-unsafe-optional-chaining */
import { useScreenSize } from '@hooks';
import { Flex } from '@styles';
import { arrayOf, func, object } from 'prop-types';
import React, { useEffect, useState } from 'react';

import Card from './Card';
import Category from './Category';

const CardSortingCategories = ({ categories, items, onError, onFinish }) => {
  const { isTabletSM } = useScreenSize();
  const [categoryBoxes, setCategoryBoxes] = useState([
    ...categories.map((item) => ({
      accepts: 'card',
      isLastItemCorrect: false,
      lastDroppedItem: null,
      title: item?.title,
    })),
  ]);
  const [cards] = useState([
    ...items.map((item) => ({ ...item, type: 'card' })),
  ]);
  const [droppedCardIds, setDroppedCardIds] = useState([]);

  useEffect(() => {
    if (droppedCardIds?.length === items?.length) {
      onFinish();
    }
  }, [droppedCardIds, items]);

  const isItemCorrect = (category, item) => category?.answers?.includes(item);

  const handleDrop = (index, item) => {
    const { id } = item;
    const ids = [...droppedCardIds, ...(id ? [id] : [])];
    const boxes = [...categoryBoxes];

    const isLastItemCorrect = isItemCorrect(categories[index], id);
    boxes[index] = {
      ...boxes[index],
      isLastItemCorrect,
      lastDroppedItem: {
        ...item,
      },
    };
    setDroppedCardIds(ids);
    setCategoryBoxes(boxes);

    if (!isLastItemCorrect) {
      onError();
      setTimeout(() => {
        boxes[index] = {
          ...boxes[index],
          isLastItemCorrect: false,
          lastDroppedItem: null,
        };
        const updatedNames = ids?.filter((n) => n !== id);
        setDroppedCardIds(updatedNames);
        setCategoryBoxes(boxes);
      }, 500);
    }
  };

  const chunkAnswers = (arr, size) =>
    Array.from({ length: Math.ceil(arr?.length / size) }, (v, i) =>
      arr?.slice(i * size, i * size + size)
    );

  return (
    <Flex flexDirection="column" gap={24} width="100%">
      <Flex flexDirection="row" gap={8}>
        {categoryBoxes?.map((category, index) => (
          <Category
            accept={category?.accepts}
            isLastItemCorrect={category?.isLastItemCorrect}
            lastDroppedItem={category?.lastDroppedItem}
            onDrop={(value) => handleDrop(index, value)}
            title={category?.title}
          />
        ))}
      </Flex>
      <Flex flexDirection="column" gap={5}>
        {chunkAnswers(cards, isTabletSM ? 2 : 3)?.map((row) => (
          <Flex flexDirection="row" gap={5}>
            {row?.map((card) => (
              <Card
                droppedCardIds={droppedCardIds}
                height={111}
                id={card?.id}
                text={card?.text}
                type={card?.type}
              />
            ))}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};

CardSortingCategories.propTypes = {
  categories: arrayOf(object).isRequired,
  items: arrayOf(object).isRequired,
  onError: func.isRequired,
  onFinish: func.isRequired,
};

export default CardSortingCategories;
